module.exports = __WEBPACK_EXTERNAL_MODULE_226__;


//////////////////
// WEBPACK FOOTER
// external "core-js/modules/es6.object.assign"
// module id = 226
// module chunks = 0